// extracted by mini-css-extract-plugin
module.exports = {"lastdrawn":"analysisbymonth_lastdrawn__vRrc-"};